import { unitTabs } from "../../constants/units";
import {
  IData,
  IUnits,
  IUnitsData,
  IUnitsTotalData,
} from "../../types/data.types";
import { ICard, InvoiceReceiptsResearchCards } from "../../types/cards.types";

export const CARDS: ICard<InvoiceReceiptsResearchCards>[] = [
  {
    key: "lastInvoiceRecDate",
    type: "date",
    label: "Last Invoice",
    label2: "Received Date",
  },
  {
    key: "invoiceNbr",
    label: "Invoice #",
  },
  {
    key: "vendorIdName",
    label: "Vendor ID",
    label2: "& Name",
  },
  {
    key: "invoiceTypeCd",
    label: "Invoice Type",
    label2: "Code",
  },
  {
    key: "uom",
    label: "UOM",
  },
  {
    key: "finalInvoiceQty",
    label: "Final Invoice",
    label2: "QTY",
  },
  {
    key: "finalPackQty",
    label: "Final Pack",
    label2: "QTY",
  },
  {
    key: "receivedUnitsEach",
    label: "Received Units",
    label2: "in Eaches",
  },
  {
    key: "nextReceiptEstimatedDate",
    type: "date",
    label: "Next Receipt",
    label2: "Estimated Date",
    forNotReceivedInvoice: true,
  },
];

export const getTotal = (
  row: IData<number>,
  data?: {
    totalWarehouseData?: IUnitsTotalData;
    totalStoreData?: IUnitsTotalData;
    column: "its" | "doh";
    tab: 0 | 1 | 2;
  }
) => {
  if (row.onOrder === undefined || row.storeInventory === undefined) {
    return undefined;
  }

  const total = row.onOrder + row.storeInventory;

  /* istanbul ignore next */
  if (data && data.totalWarehouseData && data.totalStoreData) {
    const key = unitTabs[data.tab].label.replace(" ", "");
    if (data.column === "its") {
      const demand =
        ((data.totalWarehouseData[
          `fourWeekFrwdDemand${key}` as keyof IUnitsTotalData
        ] || 0) +
          (data.totalStoreData[
            `fourWeekFrwdDemand${key}` as keyof IUnitsTotalData
          ] || 0)) /
        2;
      return total / demand;
    } else {
      const demand =
        ((data.totalWarehouseData[
          `eightWeekHstrSeln${key}` as keyof IUnitsTotalData
        ] || 0) +
          (data.totalStoreData[
            `eightWeekHstrSeln${key}` as keyof IUnitsTotalData
          ] || 0)) /
        2;
      return total / demand;
    }
  }
  return total;
};

/* istanbul ignore next */
export const getValues = (row: IUnitsData, fieldName: keyof IUnits) => {
  const response: IData<number> = {};
  if (!row) {
    return response;
  }
  Object.entries(row).forEach(([key, value]) => {
    if (key !== "inTransitToStore") {
      if (value && value[fieldName] !== undefined) {
        response[key] = value[fieldName];
      }
    }
  });
  return response;
};
